// extracted by mini-css-extract-plugin
module.exports = {"landing":"home_landing__ggzqj","cnt":"home_cnt__sXSxy","description":"home_description__UKFWs","logolanding":"home_logolanding__ygqXo"};